import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useMemo } from 'react';
import { mergeProps } from './mergeProps';
var SlotContext = React.createContext(null);
export function useSlotProps(props, defaultSlot) {
  var slot = props.slot || defaultSlot;
  var _ref = useContext(SlotContext) || {},
    _ref$slot = _ref[slot],
    slotProps = _ref$slot === void 0 ? {} : _ref$slot;
  return mergeProps(slotProps, props);
}
export function SlotProvider(props) {
  var parentSlots = useContext(SlotContext) || {};
  var _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    children = props.children;
  var value = useMemo(function () {
    return Object.keys(parentSlots).concat(Object.keys(slots)).reduce(function (o, p) {
      return _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, p, mergeProps(parentSlots[p] || {}, slots[p] || {})));
    }, {});
  }, [parentSlots, slots]);
  return React.createElement(SlotContext.Provider, {
    value: value
  }, children);
}
export function ClearSlots(props) {
  var children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  var content = React.Children.toArray(children).length <= 1 && typeof children === 'function' ? React.cloneElement(React.Children.only(children), otherProps) : children;
  return React.createElement(SlotContext.Provider, {
    value: {}
  }, content);
}
export var containsChild = function containsChild(children, type) {
  return React.Children.toArray(children).some(function (child) {
    var _child$type;
    return ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === type;
  });
};
export var hasContentSlot = function hasContentSlot(children) {
  return containsChild(children, 'EzContent');
};